import { jsxs as a, jsx as r, Fragment as b } from "react/jsx-runtime";
import { useMemo as l } from "react";
import { getDotLeft as N } from "./index.es802.js";
import s from "./index.es803.js";
import { MenuText as m } from "./index.es490.js";
import { BodyText as n } from "./index.es487.js";
const x = "ranking-bar", R = ({
  levelValue: e,
  changeAmount: i,
  additionalValue: o,
  shouldColorChangeAccordingly: d = !0,
  testId: t = x,
  formatValue: c
}) => {
  const v = l(
    () => d ? i != null && i.includes("+") ? "success" : "error" : "primary",
    [i, d]
  ), p = l(() => e ? N(e) : void 0, [e]);
  return /* @__PURE__ */ a("div", { className: s.root, "data-testid": t, children: [
    o && /* @__PURE__ */ a("div", { className: s.topTextContainer, "data-testid": t + "-additional-value", children: [
      /* @__PURE__ */ r(m, { variant: "semi-bold", children: o }),
      i && /* @__PURE__ */ r(m, { variant: "semi-bold", color: v, children: i })
    ] }),
    /* @__PURE__ */ r("div", { className: s.barContainer, children: e ? /* @__PURE__ */ a(b, { children: [
      /* @__PURE__ */ a("div", { className: s.bar, "data-testid": t + "-bar", children: [
        Array.from({ length: 3 }, (T, f) => /* @__PURE__ */ r("div", { className: s.divider, role: "separator" }, f)),
        /* @__PURE__ */ r(
          "div",
          {
            className: s.dot,
            style: { left: p },
            "data-testid": t + "-dot"
          }
        )
      ] }),
      /* @__PURE__ */ r(n, { variant: "semi-bold", testId: t + "-level-value", isEllipsis: !0, children: e })
    ] }) : /* @__PURE__ */ r(n, { variant: "semi-bold", testId: t + "-level-value", isEllipsis: !0, children: c }) })
  ] });
};
export {
  x as DEFAULT_RANKING_BAR_TESTID,
  R as RankingBar
};
//# sourceMappingURL=index.es136.js.map
